import { FC } from 'react';

import styles from './SaleCaseAnnotation.module.scss';

const SaleCasesAnnotation: FC = () => {
  return (
    <div className={styles.container}>
      {/* <dl className={styles.annotation}>
        <dt className={styles.annotation_title}>年月</dt>
        <dd className={styles.annotation_content}>売買契約の年月です。</dd>
      </dl>
      <dl className={styles.annotation}>
        <dt className={styles.annotation_title}>会社名</dt>
        <dd className={styles.annotation_content}>売主様が実際に売却を依頼した不動産会社です。</dd>
      </dl> */}
      <dl className={styles.annotation}>
        {/* <dt className={styles.annotation_title}>価格</dt> */}
        <dd className={styles.annotation_content}>※価格は下２桁を四捨五入しています。</dd>
      </dl>
    </div>
  );
};

export default SaleCasesAnnotation;
